import React, { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, BarElement, LineElement,
  PointElement, Title, Tooltip, Legend, Filler,
} from 'chart.js';
import { useTheme } from '../context/ThemeContext';
import useIsMobile from '../hooks/useIsMobile';
import SummaryTab  from './admin/SummaryTab';
import InfraTab    from './admin/InfraTab';
import DatabaseTab from './admin/DatabaseTab';
import TenantsTab  from './admin/TenantsTab';

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend, Filler);

const TABS = [
  { id: 'summary',        label: 'Summary'        },
  { id: 'infrastructure', label: 'Infrastructure'  },
  { id: 'database',       label: 'Database'        },
  { id: 'tenants',        label: 'Tenants'         },
];

export default function Admin() {
  const theme    = useTheme();
  const isMobile = useIsMobile(900);
  const [activeTab, setActiveTab] = useState(
    () => localStorage.getItem('gr-admin-tab') || 'summary'
  );

  const handleTab = (id) => {
    setActiveTab(id);
    localStorage.setItem('gr-admin-tab', id);
  };

  const padding = isMobile ? '16px 12px' : 24;

  return (
    <div>
      {/* Tab bar — sticky so it stays visible while content scrolls */}
      <div style={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        background: '#0f0f23',
        display: 'flex',
        borderBottom: `1px solid ${theme.border}`,
        padding: isMobile ? '0 12px' : '0 24px',
        overflowX: 'auto',
        overflowY: 'hidden',
      }}>
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => handleTab(tab.id)}
            style={{
              flexShrink: 0,
              padding: isMobile ? '10px 14px' : '11px 20px',
              background: 'transparent',
              border: 'none',
              borderBottom: activeTab === tab.id ? '2px solid #667eea' : '2px solid transparent',
              marginBottom: -1,
              color: activeTab === tab.id ? '#667eea' : theme.textMuted,
              fontSize: isMobile ? 12 : 13,
              fontWeight: activeTab === tab.id ? 600 : 400,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content — scrolls inside AdminLayout's single scroll container */}
      <div style={{ padding }}>
        {activeTab === 'summary'        && <SummaryTab  theme={theme} />}
        {activeTab === 'infrastructure' && <InfraTab    theme={theme} />}
        {activeTab === 'database'       && <DatabaseTab theme={theme} />}
        {activeTab === 'tenants'        && <TenantsTab  theme={theme} />}
      </div>
    </div>
  );
}
